<template>
  <v-dialog v-model="isOpen" width="330" scrollable content-class="rounded-lg">
    <v-card>
      <v-card-title
        class="pb-0 d-flex justify-space-between align-center gap-2"
      >
        <h6 class="mb-0 text-truncate">Compartilhar {{ session?.name }}</h6>
      </v-card-title>
      <v-card-text class="pt-0">
        <div class="d-flex justify-center" style="position: relative">
          <qrcode-vue
            class="d-flex justify-center pa-3 ma-1 white rounded"
            :value="qrCodeLink"
            size="260"
            level="M"
          />
          <div
            style="position: absolute; top: 0; right: 0; bottom: 0; left: 0"
            class="d-flex flex-column justify-center align-center"
          >
            <!-- <v-chip color="info" label small>
              <v-icon left small>{{ modes[mode].icon }}</v-icon>
              {{ modes[mode].text }}
            </v-chip> -->
          </div>
        </div>
        <p
          class="text-center mb-0 text-body-2 px-3"
          style="word-break: break-word; white-space: normal"
        >
          Use esse QR Code para compartilhar o relatório de validação da sessão
          <b>{{ session.name }}</b>
        </p>

        <v-divider class="my-2" />

        <v-text-field
          v-model="validity"
          label="Validade"
          type="datetime-local"
          hide-details="auto"
          outlined
          dense
        />
        <v-chip-group v-model="validity" column color="primary">
          <v-chip
            v-for="option in validityOptions"
            :key="option.value"
            :value="option.value"
            x-small
          >
            {{ option.text }}
          </v-chip>
        </v-chip-group>

        <v-btn
          v-if="canShare"
          small
          class="mt-2"
          @click="shareLink"
          block
          color="primary"
          depressed
        >
          <v-icon left small> mdi-share-outline </v-icon>
          Compartilhar link
        </v-btn>
        <v-btn
          text
          small
          class="mt-2"
          @click="copyLink"
          :disabled="copied"
          block
        >
          <v-icon left small>
            mdi-{{ copied ? "check" : "content-copy" }}
          </v-icon>
          {{ copied ? "Link copiado" : "Copiar link" }}
        </v-btn>
      </v-card-text>
      <v-card-actions class="d-flex align-end gap-1 justify-center">
        <v-btn text @click="isOpen = false"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import KJUR from "jsrsasign";
import QrcodeVue from "qrcode.vue";
import moment from "moment";

export default {
  name: "EntranceSessionRerportShare",
  components: { QrcodeVue },
  data: () => ({
    isOpen: false,
    copied: false,
    validity: null,
    canShare: !!navigator.share,
  }),

  methods: {
    open(session) {
      this.isOpen = true;
    },
    copyLink() {
      navigator.clipboard.writeText(this.qrCodeLink);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 4000);
    },
    shareLink() {
      navigator.share({
        title: `Use esse link para acessar o relatório de validação do evento ${this.party.name} • ${this.session.name}`,
        url: this.qrCodeLink,
      });
    },
  },
  mounted() {
    this.$root.$on("entrance-session-report-share-modal", this.open);
  },
  computed: {
    qrCodeLink() {
      const header = { alg: "HS256", typ: "JWT" };
      const payload = { id: this.session.id };
      if (this.validity) {
        payload.exp = moment(this.validity).unix();
      }

      var sHeader = JSON.stringify(header);
      var sPayload = JSON.stringify(payload);
      var token = KJUR.jws.JWS.sign(
        "HS256",
        sHeader,
        sPayload,
        this.session.secret
      );

      const url = new URL(window.location.href);
      url.pathname = `/staff/entrance-report/${btoa(token)}`;

      return url.href;
    },
    validityOptions() {
      const options = [
        {
          text: "Não limitar",
          value: null,
        },
        {
          text: "4 horas",
          value: moment().add(4, "hour").format("YYYY-MM-DDTHH:mm"),
        },
        {
          text: "8 horas",
          value: moment().add(3, "hour").format("YYYY-MM-DDTHH:mm"),
        },
        {
          text: "12 horas",
          value: moment().add(2, "hour").format("YYYY-MM-DDTHH:mm"),
        },
      ];
      if (this.party.endDate) {
        options.push({
          text: "Fim do evento",
          value: moment(this.party.endDate).format("YYYY-MM-DDTHH:mm"),
        });
      }
      return options;
    },
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  created() {},
};
</script>

<style></style>
